export interface TokenInfo {
  token: string;
  operation: SecuredOperation;
}

export interface TokenResponse {
  valid: boolean;
}

export enum SecuredOperation {
  LEGACY_TENANT_PROTECTION = 'LEGACY_TENANT_PROTECTION',
  LEGACY_KEY_AND_LEGAL = 'LEGACY_KEY_AND_LEGAL',
}
